import type { GridOptions, GridQueryParams } from '../types'

/** 由表格内部管理的 query 字段，不从 params 源重复合并业务参数 */
export const GRID_QUERY_ONLY_PARAM_KEYS = new Set([
  'currentPage',
  'pageSize',
  'pageSizes',
  'pageFlag',
  'sorts',
  'filters',
])

/** 将 source 中的业务参数合并进 target（跳过分页/筛选/排序等内部字段） */
export function appendBusinessQueryParams(
  target: Record<string, unknown>,
  source?: GridQueryParams,
  extraSkipKeys: Iterable<string> = []
) {
  if (!source) {
    return
  }
  const skipKeys = new Set([...GRID_QUERY_ONLY_PARAM_KEYS, ...extraSkipKeys])
  for (const [key, value] of Object.entries(source)) {
    if (skipKeys.has(key) || value == null) {
      continue
    }
    target[key] = value
  }
}

/** 合并 base 与 override 的业务参数（override 覆盖同名字段） */
export function mergeGridQueryParams(
  params: Record<string, unknown>,
  baseParams?: GridQueryParams,
  overrideParams?: GridQueryParams,
  extraSkipKeys: Iterable<string> = []
) {
  appendBusinessQueryParams(params, baseParams, extraSkipKeys)
  appendBusinessQueryParams(params, overrideParams, extraSkipKeys)
}

/** 将 options.params 中的业务参数合并进查询请求 */
export function appendExtraQueryParams(
  params: Record<string, unknown>,
  options: GridOptions,
  extraSkipKeys: Iterable<string> = []
) {
  mergeGridQueryParams(params, options.params, undefined, extraSkipKeys)
}

export interface GridQueryPaginationState {
  currentPage: number
  pageSize: number
  pageSizes?: number[]
}

/** override 中的分页字段写入 reactData 与请求 params */
export function applyQueryPaginationOverride(
  reactData: GridQueryPaginationState,
  params: Record<string, unknown>,
  override?: GridQueryParams
) {
  if (!override) {
    return
  }
  if (override.currentPage != null) {
    reactData.currentPage = override.currentPage
    params.currentPage = override.currentPage
  }
  if (override.pageSize != null) {
    reactData.pageSize = override.pageSize
    params.pageSize = override.pageSize
  }
  if (override.pageSizes != null) {
    reactData.pageSizes = override.pageSizes as number[]
  }
  if (override.pageFlag != null) {
    params.pageFlag = override.pageFlag
  }
}
